<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="checkFormBeforeSubmit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div
				class="w-100 d-flex justify-content-between"
				matTooltip="Nazwa tagu jest w PL, a tag w ENG- konieczne ze względu na poprawne wyszukiwanie. Systemy nie korzystają z polskich znaków a klienci korzystają z polskich nazw. W tagu nie może być odstępów"
			>
				<div class="form-floating w-50 me-3 mb-3">
					<input type="text" id="name" class="form-control" name="name" [(ngModel)]="data.name" required />
					<label for="name" class="form-label">Nazwa<small class="ms-2 text-danger">* wymagane</small></label>
				</div>
				<div class="form-floating w-50 ms-3 mb-3">
					<input
						type="text"
						id="tag"
						class="form-control"
						[className]="isEmpty ? 'form-control is-invalid' : 'form-control'"
						(change)="isEmptyCheck()"
						name="tag"
						[(ngModel)]="data.tag"
						required
					/>
					<label for="tag" class="form-label"
						>Tag (Hasło klucz)<small class="ms-2 text-danger">* wymagane</small></label
					>
					<div *ngIf="isEmpty" class="invalid-feedback">To pole nie może posiadać odstępów</div>
				</div>
			</div>
		</fieldset>
	</form>
</div>
